'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_display_Icon_Icon = require('../Icon/Icon.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
require('react');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableHeadSortButton", {
  root: react.css`
    ${styleMixins_reset.interactiveReset};
    display: flex;
    align-items: center;
    gap: var(--zds-space-8);
    color: ${theme_Colors.Colors.TextDefault};
    ${theme_Typography.Typography.SmallPrint2};
  `
});
const TableHeadSortButton = (props) => {
  return react.jsx(
    "button",
    { type: "button", css: Styles.root, onClick: props.onClick, "data-zds": true },
    props.children,
    react.jsx(components_display_Icon_Icon.Icon, { color: "GrayWarm6", name: "arrowDropdown", size: 16 })
  );
};

exports.TableHeadSortButton = TableHeadSortButton;
//# sourceMappingURL=TableHeadSortButton.cjs.js.map
